<!--
File: cc-cell.component.html
Project: catalog-cloud
File Created: Thursday, 17th February 2022 11:48:25
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Friday, 23rd January 2026 9:15:28 am
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<div
  class="innerCell z-0"
  [ngClass]="[
    locked ? 'cell-locked' : 'cell-unlocked',
    item ? 'cell-fill' : 'cell-void'
  ]"
  id="cell-{{ cell.data.id }}"
  pDroppable
  (onDrop)="dropCard($event)"
>
  <div
    class="flex align-items-center justify-content-center min-h-full min-w-full"
    *ngIf="loading"
  >
    <p-progressSpinner mode="indeterminate"></p-progressSpinner>
  </div>
  
  <app-cc-cell-item
    *ngIf="item"
    [locked]="locked"
    [item]="item"
    (remove)="removeData()"
    (productModelChange)="changeProductModel($event)"
    (productVariantChange)="changeProductVariant($event)"
    (productExtraChange)="changeProductExtra($event)"
    [height]="height"
    [width]="width"
    [ngClass]="viewItem ? '' : 'hide-item'"
    [idPage]="idPage"
    [idCellPage]="idCellPage"
    [pageCell]="cell.data"
    [idCatalog]="idCatalog"
    [idFascicle]="idFascicle"
  >
  </app-cc-cell-item>

  <div class="cell-buttons" *ngIf="!locked && allowChangeCells">
    <app-cc-cell-button
      [grid]="grid"
      [cellId]="grid.cells.indexOf(cell)"
      [side]="'right'"
      class="side side-h side-right"
      (sizeChanged)="refreshCell()"
    ></app-cc-cell-button>
    <app-cc-cell-button
      [grid]="grid"
      [cellId]="grid.cells.indexOf(cell)"
      [side]="'left'"
      class="side side-h side-left"
      (sizeChanged)="refreshCell()"
    ></app-cc-cell-button>
    <app-cc-cell-button
      [grid]="grid"
      [cellId]="grid.cells.indexOf(cell)"
      [side]="'top'"
      class="side side-v side-top"
      (sizeChanged)="refreshCell()"
    ></app-cc-cell-button>
    <app-cc-cell-button
      [grid]="grid"
      [cellId]="grid.cells.indexOf(cell)"
      [side]="'bottom'"
      class="side side-v side-bottom"
      (sizeChanged)="refreshCell()"
    ></app-cc-cell-button>
  </div>
</div>
